import { create } from "zustand";

type MarketingFlowState = {
  // 마케팅 동의 팝업이 동의/거부 후 알럿 확인으로 닫힌 뒤 1회 실행할 콜백
  afterClose: (() => void) | null;
  setAfterClose: (cb: (() => void) | null) => void;
  consumeAfterClose: () => void;
};

export const useMarketingFlowStore = create<MarketingFlowState>((set, get) => ({
  afterClose: null,
  setAfterClose: (cb) => set({ afterClose: cb }),
  consumeAfterClose: () => {
    const { afterClose } = get();
    if (afterClose) {
      set({ afterClose: null });
      afterClose();
    }
  },
}));
